import Stack from "@mui/material/Stack";
import AuthFooter from "components/cards/AuthFooter";

export default function Footer() {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        width: "100%",
        p: "16px",
        bgcolor: "#FAFAFB",
        mt: "auto",
      }}
    >
      <AuthFooter />
    </Stack>
  );
}
